export const images = {
  noData: require('./no_results.webp'),
  somethingWentWrong: require('./sth_went_wrong.webp'),
};
